import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse } from 'antd';
import UIComponent from './uiComponent';
import { resovleContent } from './utils';
import UITheme from './uiTheme';
export default class UIPanel extends UIComponent {
    title;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        resovleContent(this, s);
    }
    getComponent() {
        const children = [];
        for (const c of this.children) {
            const component = c.getComponent();
            children.push(component);
        }
        return (_jsx(UITheme, { children: _jsx(Collapse, { defaultActiveKey: ['1'], children: _jsx(Collapse.Panel, { header: this.title, children: children }, "1") }) }));
    }
}
//# sourceMappingURL=uiPanel.js.map